import { render, staticRenderFns } from "./Beginpage.vue?vue&type=template&id=21ddd7e1&scoped=true"
import script from "./Beginpage.vue?vue&type=script&lang=js"
export * from "./Beginpage.vue?vue&type=script&lang=js"
import style0 from "./Beginpage.vue?vue&type=style&index=0&id=21ddd7e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ddd7e1",
  null
  
)

export default component.exports